module.exports = "/_next/static/images/quatro-50e6a553680daf87d301df2f99041ac8.jpg";